const countries = [
  {
    code: "NG",
    name: "Nigeria",
    currency: "NGN",
    phoneCode: "+234",
    hasLocations: true,
  },
  {
    code: "GH",
    name: "Ghana",
    currency: "GHS",
    phoneCode: "+233",
    hasLocations: true,
  },
  {
    code: "KE",
    name: "Kenya",
    currency: "KES",
    phoneCode: "+254",
    hasLocations: true,
  },
  {
    code: "ZA",
    name: "South Africa",
    currency: "ZAR",
    phoneCode: "+27",
    hasLocations: true,
  },
  {
    code: "UG",
    name: "Uganda",
    currency: "UGX",
    phoneCode: "+256",
    hasLocations: false,
  },
  {
    code: "TZ",
    name: "Tanzania",
    currency: "TZS",
    phoneCode: "+255",
    hasLocations: false,
  },
  {
    code: "RW",
    name: "Rwanda",
    currency: "RWF",
    phoneCode: "+250",
    hasLocations: false,
  },
  {
    code: "CM",
    name: "Cameroon",
    currency: "XAF",
    phoneCode: "+237",
    hasLocations: false,
  },
  {
    code: "SN",
    name: "Senegal",
    currency: "XOF",
    phoneCode: "+221",
    hasLocations: false,
  },
  {
    code: "CI",
    name: "Ivory Coast",
    currency: "XOF",
    phoneCode: "+225",
    hasLocations: false,
  },
  {
    code: "ZM",
    name: "Zambia",
    currency: "ZMW",
    phoneCode: "+260",
    hasLocations: false,
  },
  {
    code: "ZW",
    name: "Zimbabwe",
    currency: "USD",
    phoneCode: "+263",
    hasLocations: false,
  },
  {
    code: "BW",
    name: "Botswana",
    currency: "BWP",
    phoneCode: "+267",
    hasLocations: false,
  },
  {
    code: "NA",
    name: "Namibia",
    currency: "NAD",
    phoneCode: "+264",
    hasLocations: false,
  },
  {
    code: "ET",
    name: "Ethiopia",
    currency: "ETB",
    phoneCode: "+251",
    hasLocations: false,
  },
];

export default countries;